module.exports = __webpack_public_path__ + "img/Logo-26.549f7911.svg";